import React from 'react'

export const SunilArora = () => {
  return (
    <div className="arora-padding">
    <section id="ft-team-details" className="ft-team-details-section">
        <div className="container">
            <div className='row'>
                <div className='col-lg-7'>
                    <div className="ft-team-details-text-wrapper headline pera-content">
                        <div className="ft-team-details-text ">
                            <h2>Mr. Sunil Arora, CEO</h2>
                            <p> Sunil Arora is a powerhouse in the global logistics landscape with over 33 years of leadership in freight forwarding, customs clearance, and cargo operations. As CEO of One World Network, based in Dubai, he is building a world-class logistics alliance with a clear vision: to empower independent freight forwarders through meaningful global partnerships.  

He  has also served as President of both ACCAI and ACCD, and as a senior advisor to key industry bodies. He has worked closely with India's Ministry of Civil Aviation, DGCA, BCAS, and major trade chambers like CII and FICCI. Honored with the 'Mentor of the Year' award and named a 'Logistics Industry Ambassador,' his reputation is built on insight, influence, and integrity. Sunil continues to champion industry innovation, policy advocacy, and global collaboration—cementing his status as a leading voice in international logistics. </p>
                            <div className="content">
                                <div className="info">
                                    <div className='info-one'>
                                    <div className="icon">
                                        <i className="fa fa-phone-alt"></i>
                                    </div>
                                    </div>
                                    <div className='w-100 text-md-100'><h4>
                                        <span>+91-98110 15573 / +971-54 522 3903</span>
                                    </h4></div>
                                </div>
                                <div className="info">
                                    <div  className='info-one'>
                                    <div className="icon">
                                        <i className="fa fa-envelope" aria-hidden="true"></i>
                                    </div>
                                    </div>
                                    <div className='w-100 text-md-100'>
                                    <h4>
                                        <a href="mailto:ceo@oneworldnetwork.co" rel="noopener noreferrer" target="_blank">ceo@oneworldnetwork.co</a>  
                                        {/* <a href='#'>ceo@oneworldnetwork.co</a> */}
                                    </h4>
                                    </div>
                                </div>
                                <div className="info">
                                   <div  className='info-one'>
                                   <div className="icon">
                                    <i class="fab fa-linkedin-in"></i>
                                    </div>
                                   </div>
                                    <div className='w-100 text-md-100'>
                                    <h4>
                                        <a href='https://www.linkedin.com/in/sunil-arora-93841537?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app ' rel="noopener noreferrer" target="_blank">Click to visit Linkedin profile</a>
                                    </h4>
                                    </div>
                                </div>
                            </div>
            
                        </div>
                    </div>
                </div>
                <div className='col-lg-5'>
                    <div className="ft-team-details-img position-relative">
                        <img src="images/resources/sunil-sir.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
  )
}
